import { Group } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';

interface DateRangeFilterProps {
  /** `YYYY-MM-DD` (Mantine v8's `DateStringValue` — @mantine/dates/types/
   * GeneralTypes.d.ts). `DatePickerInput`'s `onChange` always reports this string
   * form regardless of what `value` was given, so state is kept as a string
   * throughout rather than round-tripping through `Date`. */
  from: string | null;
  to: string | null;
  onFromChange: (value: string | null) => void;
  onToChange: (value: string | null) => void;
  /** Mass balance requires both ends; most other reports treat an unbounded range
   * as valid (BUILD_SPEC's own `from`/`to` are optional on those query schemas). */
  required?: boolean;
}

/** Shared "From"/"To" date filter (BUILD_SPEC.md §13: "All filterable"). Every
 * report's `from`/`to` are inclusive business-date bounds (packages/core/src/
 * schemas/reporting.ts's `siteAndRangeSchema`) — see api.ts's `rangeQuery` for how
 * these date-only strings become inclusive-of-the-whole-day query params. */
export function DateRangeFilter({ from, to, onFromChange, onToChange, required }: DateRangeFilterProps) {
  return (
    <Group gap="xs" wrap="wrap">
      <DatePickerInput
        label="From"
        placeholder="Start date"
        value={from}
        onChange={onFromChange}
        maxDate={to ?? undefined}
        clearable={!required}
        w={170}
      />
      <DatePickerInput
        label="To"
        placeholder="End date"
        value={to}
        onChange={onToChange}
        minDate={from ?? undefined}
        clearable={!required}
        w={170}
      />
    </Group>
  );
}
